import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { TimeClockProvider } from './hooks/useTimeClock';
import { ThemeProvider } from './hooks/useTheme';
import { HashRouter } from 'react-router-dom';

const originalFetch = window.fetch;

window.fetch = async (url: RequestInfo | URL, options?: RequestInit): Promise<Response> => {
    const isApiUrl = typeof url === 'string' && url.startsWith('/api/');

    if (!isApiUrl) {
        return originalFetch(url, options);
    }
    
    const newOptions = { ...options };

    if ((window as any).electronAPI && typeof (window as any).electronAPI.getSecretKey === 'function') {
        try {
            const secretKey = await (window as any).electronAPI.getSecretKey();
            if (secretKey) {
                newOptions.headers = { ...options?.headers, 'X-App-Secret-Key': secretKey };
            }
        } catch (err) {
            console.error("Error getting secret key, proceeding without it:", err);
        }
    }
    
    return originalFetch(url, newOptions);
};


const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <HashRouter>
      <ThemeProvider>
        <TimeClockProvider>
          <App />
        </TimeClockProvider>
      </ThemeProvider>
    </HashRouter>
  </React.StrictMode>
);